import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import moment from 'jalali-moment';
import React from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {DeleteBotoomSheet} from '..';
import EmptyImg from '../../../../../assets/image/shared/empty.svg';
import {clearAllData} from '../../../../../store/redux/addPictureAdvertisment';
import {
  addRegisterAdvertisement,
  resetAllAdvertisementData,
  resetFormData,
  resetOptionalFormData,
  resetRegisterAdvertisement,
} from '../../../../../store/redux/advertisementRegisteration';
import {getValidImage} from '../../../../../utilities/helper/getValidImage/getValidImage';

interface MySaleCardProps {
  data: IMyAdvertismentData;
  setDeleteItem: React.Dispatch<React.SetStateAction<DeleteBotoomSheet>>;
  type?: string;
}
const MySaleCard = ({data, setDeleteItem, type}: MySaleCardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const mainImage =
    data && getValidImage(data.main_image as unknown as img, '128');
  const subBrandImage =
    data && getValidImage(data.sub_brand_main_image!, '128');
  const displayImage = mainImage || subBrandImage;

  return (
    <div
      className={classNames(
        'w-full  px-2 gap-3  items-center h-[128px] flex rounded-[8px] shadow-sm relative py-2 my-2',
        {
          'bg-red-50': data.status === 'rejected',
          'bg-white': data.status !== 'rejected',
        },
      )}
    >
      {displayImage ? (
        <div>
          <img
            className="rounded-[8px] min-w-[112px] h-[112px]"
            width={112}
            height={112}
            src={displayImage}
            alt={data?.title}
          />
        </div>
      ) : (
        <div className="flex items-center justify-center w-[112px] h-[112px] rounded-[8px] min-w-[112px] bg-gray-100">
          <img className="" width={50} height={50} src={EmptyImg} alt="" />
        </div>
      )}

      <div className="flex flex-col justify-between py-2 w-full h-full">
        <div className="flex flex-col gap-2">
          <span className="text-[#1A1A1A] text-md font-Medium">
            {data.title}
          </span>
          <div className="flex gap-1 items-center text-sm text-gray-700 font-Regular">
            <SpanIcon className="text-xl icon-nameLocation" />
            <span>
              {data?.state?.name || ''} {data?.city?.name || ''}
            </span>
          </div>
        </div>
        <div className="flex justify-between w-full">
          {data.status === 'rejected' && (
            <span className="flex justify-center items-center p-1 text-xs text-red-500">
              رد شده
            </span>
          )}
          {data.status === 'pending' && (
            <span className="flex items-center justify-center rounded-[8px] text-xs text-warning-400 p-1">
              در انتظار تایید
            </span>
          )}
          {data.status === 'published' && (
            <span className={classNames('text-xs text-gray-700 font-Regular')}>
              {data.published_at &&
                moment(moment(new Date(data.published_at)))
                  .locale('fa')
                  .from(new Date())}
            </span>
          )}

          {data.status === 'published' && (
            <span
              className="text-sm font-Medium text-farm-shop-600"
              onClick={() => {
                dispatch(resetAllAdvertisementData());
                navigate(`/my-ads/advertisment/${data.guid}`, {
                  state: {
                    type: type,
                    requirement_type: data.requirement_type,
                    advertisement_type: data.advertisement_type,
                    from: location?.pathname,
                  },
                });
              }}
            >
              مدیریت آگهی
            </span>
          )}
          {data.status === 'rejected' && (
            <div className="flex gap-2 items-center text-sm text-farm-shop-500">
              <span
                onClick={() => {
                  dispatch(resetRegisterAdvertisement({}));
                  dispatch(clearAllData());
                  dispatch(resetOptionalFormData(''));
                  dispatch(resetFormData(''));
                  dispatch(
                    addRegisterAdvertisement({
                      ad_type: {
                        title: 'آگهی شخصی',
                        value: 'personal',
                      },
                    }),
                  );
                  navigate(
                    `/edit/advertisment/${data.guid}/${
                      data.advertisement_type ?? data.requirement_type
                    }`,
                    {
                      state: {
                        type: type,
                        requirement_type: data.requirement_type,
                        advertisement_type: data.advertisement_type,
                      },
                    },
                  );
                }}
              >
                رفع نواقص
              </span>
              <span
                className="text-red-500"
                onClick={() => setDeleteItem({isOpen: true, data: data})}
              >
                حذف
              </span>
            </div>
          )}
          {data.status === 'expired' && (
            <div className="flex flex-1 gap-2 justify-between text-sm">
              <span className="flex text-gray-400">منقضی شده</span>
              <span
                className="flex text-farm-shop-500"
                onClick={() => {
                  dispatch(resetAllAdvertisementData());
                  navigate(`/my-ads/advertisment/${data.guid}`, {
                    state: {
                      type: type,
                      requirement_type: data.requirement_type,
                      advertisement_type: data.advertisement_type,
                      from: location?.pathname,
                    },
                  });
                }}
              >
                مدیریت آگهی
              </span>
            </div>
          )}
          {data.status === 'pending' && (
            <>
              {data?.ad_price ? (
                <div className='text-[#1A1A1A] text-md font-Medium"'>
                  {data.ad_price.toLocaleString()}{' '}
                  <span className="text-xs">تومان</span>
                </div>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MySaleCard;
